/**
 * A link to one publication on the Monitor: `/$org/compliance/regulatory`
 * with the hash `publication-<id>`. The Monitor opens that publication's row
 * and scrolls to it, so Home's agenda (and anything else) can point at the
 * update itself rather than at the list.
 *
 * @module components/regulation/monitor/publicationLink
 */
const PREFIX = "publication-";

/** The hash for a publication (without "#", as TanStack Router's `hash` option takes it). */
export const publicationHash = (updateId: string): string => `${PREFIX}${updateId}`;

/** The publication a location hash names, with or without a leading "#", or null. */
export function publicationIdFromHash(hash: string | null | undefined): string | null {
  const value = (hash ?? "").replace(/^#/, "");
  if (!value.startsWith(PREFIX)) return null;
  let id: string;
  try {
    id = decodeURIComponent(value.slice(PREFIX.length));
  } catch {
    // A malformed escape ("#publication-%") names nothing; it must not throw in render.
    return null;
  }
  return id.length > 0 ? id : null;
}
